import { useEffect } from 'react';
import styles from './result.module.css';
declare global {
    interface Window {
      adsbygoogle: any;
    }
  }
const Ads = ({ style = { display: "flex", height: '120px',  width: 'auto' }, sideBar = true, includeScript = true, adsSlot='2689082759' }) => {

    if (process.env.NEXT_PUBLIC_AD_SENSE_ACCOUNT_ID === 'false') {
        return null;
    }
   if (includeScript) {
    useEffect(() => {
        let ads = document.getElementsByClassName('adsbygoogle').length;
        for (let i = 0; i < ads; i++) {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (e) { }
        }
    }, []);
   }
   
   const adTestIns = process.env.NEXT_PUBLIC_AD_SENSE_TEST_MODE === 'on' ? {'data-adtest': process.env.NEXT_PUBLIC_AD_SENSE_TEST_MODE} : {};
   const adTest = process.env.NEXT_PUBLIC_AD_SENSE_TEST_MODE === 'on' ? {'data-adbreak-test': process.env.NEXT_PUBLIC_AD_SENSE_TEST_MODE}  : {};


   
    return (
        <>
            {includeScript && (
                <script async src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${process.env.NEXT_PUBLIC_AD_SENSE_ACCOUNT_ID}`}
                    crossOrigin="anonymous" {...adTest}></script>
            )}

            <ins className={sideBar ? 'adsbygoogle' : `adsbygoogle ${styles.panarama}`}
                style={style}
                data-ad-client={process.env.NEXT_PUBLIC_AD_SENSE_ACCOUNT_ID}
                data-ad-slot={adsSlot}
                data-ad-format="fluid"
                {...adTestIns}
                data-full-width-responsive="true">
            </ins>

        </>
    );
}

export default Ads;